import { getDelegationTokenForOwa } from 'owa-tokenprovider';
import { MSATOKENSCOPE } from '../FeedbackConstants';

export default async function getTokenForOds(): Promise<string> {
    let token = null;
    token = await getDelegationTokenForOwa(MSATOKENSCOPE);

    return token;
}
